import React, { PropsWithChildren } from "react";
import { flushSync } from "react-dom";
import { useReactToPrint } from "react-to-print";
import { SpinnerLoading } from "../styles";
import * as S from "./styles";

export interface IComponentToPrintProps {
  labelTrigger: string;
  fileName?: string;
  onBeforeGetContent?: () => Promise<any>;
}
const BasePrintPDF = ({
  children,
  labelTrigger,
  fileName = "",
  onBeforeGetContent = () => Promise.resolve()
}: PropsWithChildren<IComponentToPrintProps>) => {
  const componentRef = React.useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [dataForPrint, setDataForPrint] = React.useState<any>({});

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: fileName,
    onBeforePrint: async () => {
      try {
        setIsLoading(true);
        const result = await onBeforeGetContent();
        flushSync(() => {
          setDataForPrint(result);
        });
      } catch (error) {
        // handle error
      } finally {
        setIsLoading(false);
      }
    },
    onAfterPrint: () => { },
  });

  return (
    <S.Container>
      <S.ButtonPrint
        disabled={isLoading}
        onClick={handlePrint}
      >
        {labelTrigger}
        {isLoading && <SpinnerLoading customSize="14px" noMargin />}
      </S.ButtonPrint>
      <S.ContainerComponentToPrint>
        {React.cloneElement(children as React.ReactElement, {
          ref: componentRef,
          dataResponseAsync: dataForPrint,
        })}
      </S.ContainerComponentToPrint>
    </S.Container>
  );
};

export default BasePrintPDF;
